import { useState, useEffect } from 'react';
import { useNavigate } from '@usas/ui-web/wrappers/ReactRouterDom';

import getLeftNavigationState from './GetLeftNavigationState';

import useOmeMeetData from '../../state/omeMeet/UseOmeMeetData';
import useOmeMeetEntryData from '../../state/omeMeetEntry/UseOmeMeetEntryData';
import useOrgUnitAthleteEntryInfoData from '../../state/orgUnitAthleteEntryInfo/UseOrgUnitAthleteEntryInfoData';
import useOmeMeetOrgUnitAthleteEntryIndividualRosterEntryData from '../../state/omeMeetOrgUnitAthleteEntryIndividualRosterEntry/UseOmeMeetOrgUnitAthleteEntryIndividualRosterEntryData';
import useOmeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryData from '../../state/omeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntry/UseOmeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryData';
import useOrgUnitAthleteEntryPurchaseData from '../../state/orgUnitAthleteEntryPurchase/UseOrgUnitAthleteEntryPurchaseData';

import useMeetData from '@usas/ui-web/state/meet/UseMeetData';
import useEnvironmentVariableData from '@usas/ui-web/state/environmentVariable/UseEnvironmentVariableData';
import useLeftNavModalData from '@usas/ui-web/state/leftNavModal/UseLeftNavModalData';
import useNavRoutes from '@usas/ui-web/state/security/UseNavRoutes';

import { formatDate } from '@usas/ui-web/utils/DateFunctions';

const INITIAL_STATE = { items: [], meetName: '', meetHost: '', meetClassification: '', meetDates: '' };

const useLeftNavigation = (viewName) => {
  const navigate = useNavigate();
  const { isReadyToRoute } = useNavRoutes();
  const [leftNavState, setLeftNavState] = useState(INITIAL_STATE);
  const { omeMeetState } = useOmeMeetData();
  const { omeMeetEntryState } = useOmeMeetEntryData();
  const { orgUnitAthleteEntryInfoState } = useOrgUnitAthleteEntryInfoData();
  const { omeMeetOrgUnitAthleteEntryIndividualRosterEntryState } = useOmeMeetOrgUnitAthleteEntryIndividualRosterEntryData();
  const { omeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryState } = useOmeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryData();
  const { orgUnitAthleteEntryPurchaseState } = useOrgUnitAthleteEntryPurchaseData();
  const { meetState } = useMeetData();
  const { environmentVariableState } = useEnvironmentVariableData();
  const { leftNavModalState, setLeftNavModalState } = useLeftNavModalData();

  const getMeetName = () => {
    if (orgUnitAthleteEntryInfoState?.objData?.meetName) {
      return `${orgUnitAthleteEntryInfoState?.objData?.meetName}`
    } else {
      return null;
    }
  };

  const getMeetHostName = () => {
    if (orgUnitAthleteEntryInfoState?.objData?.hostOrgUnitName) {
      return `${orgUnitAthleteEntryInfoState?.objData?.hostOrgUnitName}`
    } else {
      return null;
    }
  };

  const getMeetClassification = () => {
    if (orgUnitAthleteEntryInfoState?.objData?.meetClassificationName) {
      return `${orgUnitAthleteEntryInfoState?.objData?.meetClassificationName}`
    } else {
      return null;
    }
  };

  const getMeetDates = () => {
    if (orgUnitAthleteEntryInfoState?.objData?.meetStartDate || orgUnitAthleteEntryInfoState?.objData?.meetEndDate) {
      return `${formatDate(orgUnitAthleteEntryInfoState?.objData?.meetStartDate)} - ${formatDate(orgUnitAthleteEntryInfoState?.objData?.meetEndDate)}`
    } else {
      return null;
    }
  };

  const getAthleteEntryStatus = () => {
    if (omeMeetOrgUnitAthleteEntryIndividualRosterEntryState?.objData?.status) {
      return `${omeMeetOrgUnitAthleteEntryIndividualRosterEntryState?.objData?.status}`;
    }
    else {
      return null;
    }
  }

  const onNavigateToPath = (e, path) => {
    if (e?.preventDefault) {
      e.preventDefault();
    }
    setLeftNavModalState({
      ...leftNavModalState,
      modalTitle: 'The information on this page has not been saved',
      displayPopUp: false,
      formStateSaved: true,
      path: ''
    });

    navigate(path);
  };

  useEffect(() => {
    if (isReadyToRoute === true && environmentVariableState.isLoaded === true) {
      const items = getLeftNavigationState(viewName, omeMeetState.route, orgUnitAthleteEntryInfoState.objData);
      const meetName = getMeetName();
      const meetHost = getMeetHostName();
      const meetClassification = getMeetClassification();
      const meetDates = getMeetDates();
      const athleteEntryStatus = getAthleteEntryStatus();
      setLeftNavState({
        ...leftNavState,
        items,
        meetName,
        meetHost,
        meetClassification,
        meetDates,
        athleteEntryStatus
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [environmentVariableState, omeMeetState, meetState, omeMeetEntryState, orgUnitAthleteEntryInfoState, omeMeetOrgUnitAthleteEntryIndividualRosterEntryState,
    omeMeetOrgUnitNonAthleteEntryOrgUnitAthleteEntryState, orgUnitAthleteEntryPurchaseState, viewName, isReadyToRoute]);

  return { ...leftNavState, leftNavState, onNavigateToPath, orgUnitAthleteEntryInfoState };
};

export default useLeftNavigation;
